export enum EIMLTypeSubstratMineral {
    VAL = 1,
    S = 2,
    GR = 3,
    GA = 4,
    BD = 5
}